import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=21838425&scoped=true"
import script from "./AppLoading.vue?vue&type=script&lang=ts"
export * from "./AppLoading.vue?vue&type=script&lang=ts"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=21838425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21838425",
  null
  
)

export default component.exports